import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  interestingLinks: [],
  query: '',
};

const interestingLinksSlice = createSlice({
  name: 'interestingLinks',
  initialState,
  reducers: {
    setInterestingLinks: (state, action) => {
      state.interestingLinks = action.payload;
    },
    setInterestingLinksQuery: (state, action) => {
      state.query = action.payload;
    },
  },
});

export const { setInterestingLinks, setInterestingLinksQuery } = interestingLinksSlice.actions;

export default interestingLinksSlice.reducer;
